import script from "./FordConfigWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./FordConfigWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./FordConfigWorkspace.vue?vue&type=style&index=0&id=3b37e7ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b37e7ae"]])

export default __exports__